import i18next from "i18next";

export const lang = (key) => {
  return i18next.t(key);
};
